import { Controller } from "@hotwired/stimulus";

// Submits the form on change; text inputs wait until typing pauses.
export default class extends Controller {
  static values = { delay: { type: Number, default: 300 } };

  submit() {
    clearTimeout(this.timeout);
    this.element.requestSubmit();
  }

  debouncedSubmit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.element.requestSubmit(), this.delayValue);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
